import { Navigate, useLocation } from 'react-router-dom';
import { PageLoader } from '@/components/common/LoadingSpinner';
import { useAuthStore } from '@/stores/authStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Protected route wrapper.
 * Redirects to sign-in if the user is not authenticated.
 * Shows a loader while the session is being restored on page load.
 * Preserves the attempted URL so the user is redirected back after login.
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuthStore();

  if (isLoading) {
    return <PageLoader text="Checking authentication..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/sign-in" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
